<div style="display: flex;align-items: center;margin-bottom: 8px;">
    <div class="ui small header m-0" style="flex:1;">
        Kart Menüsü
    </div>
    <button nz-button
            (click)="nzModalRef.close()"
            nzType="text"
            nzShape="circle"
            nzSize="small"><nz-icon nzType="close" />
    </button>
</div>

<div class="kart-menu-grid" role="menu" aria-label="Kart işlemleri">
    <button class="kart-menu-btn" (click)="tiklandiKartDuzenle()" role="menuitem" aria-label="Kartı düzenle">
        <nz-icon nzType="edit" />
        <span>Düzenle</span>
    </button>

    <button class="kart-menu-btn" [class.fiko-kilit]="!lisans('kart_klon')" (click)="tiklandiKartKopyala()" role="menuitem" aria-label="Kartı kopyala">
        <nz-icon nzType="copy" />
        <span>Kopyala</span>
    </button>

    <button class="kart-menu-btn" [class.fiko-kilit]="!lisans('sablon_olustur')" (click)="tiklandiSablonKaydet()" role="menuitem" aria-label="Şablon olarak kaydet">
        <nz-icon nzType="save" />
        <span>Şablon Kaydet</span>
    </button>

    <button class="kart-menu-btn" (click)="tiklandiSabitle()" role="menuitem" [attr.aria-label]="kart()?.sabitlendi ? 'Sabitlemeyi kaldır' : 'Kartı sabitle'">
        <nz-icon nzType="pushpin" />
        <span>{{ kart()?.sabitlendi ? 'Çöz' : 'Sabitle' }}</span>
    </button>

    <button class="kart-menu-btn" (click)="tiklandiKoleksiyonaEkle()" role="menuitem" aria-label="Koleksiyona ekle">
        <nz-icon nzType="folder-open" />
        <span>Koleksiyon</span>
    </button>

    <button class="kart-menu-btn" (click)="tiklandiLinkKopyala()" role="menuitem" aria-label="Kart linkini kopyala">
        <nz-icon nzType="link" />
        <span>Link Kopyala</span>
    </button>

    <button class="kart-menu-btn" (click)="tiklandiHatirlatma()" role="menuitem" aria-label="Hatırlatma ayarla">
        <nz-icon nzType="clock-circle" />
        <span>Hatırlat</span>
    </button>

    <div *ngIf="hatirlatmaPaneliAcik" style="grid-column: 1/-1; padding: 8px 12px; display: flex; gap: 8px; align-items: center;">
        <nz-date-picker
            [(ngModel)]="hatirlatmaTarihi"
            nzShowTime
            nzFormat="dd.MM.yyyy HH:mm"
            nzPlaceHolder="Tarih seç"
            style="flex: 1;"
            nzSize="small"></nz-date-picker>
        <button nz-button nzType="primary" nzSize="small" (click)="hatirlatmaKaydet()">Kaydet</button>
    </div>

    <button class="kart-menu-btn kart-menu-btn--tehlike"
            nz-popconfirm
            nzPopconfirmTitle="Bu kart silinecek. Emin misiniz?"
            nzOkText="Evet, Sil"
            nzCancelText="Vazgeç"
            nzOkDanger
            nzPopconfirmPlacement="top"
            (nzOnConfirm)="tiklandiKartSil()"
            role="menuitem"
            aria-label="Kartı sil">
        <nz-icon nzType="delete" />
        <span>Sil</span>
    </button>
</div>
